var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteBlackLineOff = function SvgFavoriteBlackLineOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13.528 5.333c.193-.39.75-.39.943 0l2.495 5.057a.526.526 0 0 0 .396.287l5.58.811a.526.526 0 0 1 .292.897l-4.038 3.936a.525.525 0 0 0-.151.465l.953 5.558a.526.526 0 0 1-.763.554l-4.99-2.624a.526.526 0 0 0-.49 0l-4.992 2.624a.526.526 0 0 1-.762-.554l.953-5.558a.526.526 0 0 0-.151-.465l-4.038-3.936a.526.526 0 0 1 .291-.897l5.58-.81a.525.525 0 0 0 .396-.288l2.496-5.057Z"
  })));
};
export default SvgFavoriteBlackLineOff;